import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import {
  formatAccessTime,
  formatFloor,
  formatMinLeaseTerm,
  formatPriceForWorkplace,
  formatTotalArea,
  operationalCosts,
  priceFormatter,
  utilityCharges,
} from '../../../../../utils/bargain_terms_formatter';
import { getFloorsRangeWithTotalFloors } from '../../../../../utils/getFloorsRangeWithTotalFloors';
import { getIsWorkplaceInCoworking } from '../../../../../utils/validators';

export function coworkingRentTermsMapper(offer: IOfferSchema): Array<[string, string | Array<string>]> {
  const {
    bargainTerms: { includedOptions, minLeaseTerm, priceForWorkplace },
    building,
    coworking,
    coworkingOfferType,
    floorFrom,
    floorNumber,
    floorTo,
    totalArea,
  } = offer;

  const isWorkplaceInCoworking = getIsWorkplaceInCoworking(coworkingOfferType);

  const terms: Array<[string, string | Array<string>]> = [];

  terms.push(['Цена за рабочее место', formatPriceForWorkplace(priceForWorkplace)]);

  if (!isWorkplaceInCoworking) {
    terms.push(['Цена за весь офис', priceFormatter(offer)]);
  }

  terms.push(
    ['Коммунальные платежи', utilityCharges(includedOptions)],
    ['Эксплуатационные расходы', operationalCosts(includedOptions)],
    ['Срок аренды', formatMinLeaseTerm(minLeaseTerm)],
  );

  if (!isWorkplaceInCoworking) {
    terms.push(['Площадь', formatTotalArea(totalArea)]);
  }

  if (building?.floorsCount && floorFrom && floorTo) {
    terms.push(['Этаж', getFloorsRangeWithTotalFloors('outOfTotal')(floorFrom, floorTo, building.floorsCount)]);
  } else {
    terms.push(['Этаж', formatFloor(floorNumber, building)]);
  }

  terms.push(['Доступ', formatAccessTime(coworking)]);

  return terms;
}
